import { useState } from 'react'
import { useAct } from 'DashboardUser/store'
import restClient from 'Shared/hooks/restClient'
import OrganisationPickerModal from 'Shared/components/OrganisationPicker/OrganisationPickerModal'
import { FilterPill } from '../Filters'

export default function OrganisationFilter() {
  const act = useAct()
  const organisationId = useSel(s => s.local.filters.organisationId);
  const [organisationName, setOrganisationName] = useState(null)
  const [open, setOpen] = useState(false)

  function onPick(organisationId) {
    console.log('Organisation selected:', organisationId)
    act.local.setFilter('organisationId', organisationId);
  }

  function clearFilter() {
    act.local.setFilter('organisationId', null);
  }

  useEffect(() => {
    if (!organisationId) {
      setOrganisationName(null)
      return
    }
    restClient
      .get(`/api/organisations/${organisationId || 'national'}`)
      .then(({ data: { name } }) => setOrganisationName(name))
  }, [organisationId])

  const title = organisationName ? `${organisationName} (Change)` : 'Filter by organisation'

  return <div className='filter-field'>
    <label>Organisation</label>
    <div className='fake-select-wrapper'>
      <div className='fake-select' onClick={() => setOpen(true)}>
        <span>{title}</span>
        <svg className='dropdown-icon' viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </div>
      {organisationName && (
        <button className='clear-filter' onClick={clearFilter} title="Clear filter">
          ×
        </button>
      )}
    </div>
    <OrganisationPickerModal open={open} hide={() => setOpen(false)} onPick={onPick} />
  </div>
}

export function OrganisationPill({ value, onClear }) {
  const [organisationName, setOrganisationName] = useState(null)

  useEffect(() => {
    if (!value) {
      setOrganisationName(null)
      return
    }
    restClient
      .get(`/api/organisations/${value}`)
      .then(({ data: { name } }) => setOrganisationName(name))
  }, [value])

  if (!value) {
    return <></>;
  }

  return <FilterPill onClear={onClear}>
    Organisation: {organisationName}
  </FilterPill>
}